<template>
  <div
    class="trezo-card bg-primary-600 mb-[25px] p-[20px] md:p-[25px] rounded-md relative z-[1]"
  >
    <div class="trezo-card-content">
      <div class="sm:grid sm:grid-cols-5 gap-[25px]">
        <div class="sm:col-span-3">
          <h3 class="text-[20px] mb-[2px] text-white">
            Hi, <span class="text-orange-100">Dr. Olivia!</span>
          </h3>
          <p class="text-white">Your schedule today</p>
          <div
            class="info flex items-center mt-[20px] sm:mt-[60px] md:mt-[76px]"
          >
            <div
              class="flex items-center ltr:mr-[30px] rtl:ml-[30px] ltr:last:mr-0] rtl:ml-0"
            >
              <div
                class="bg-orange-100 text-orange-500 flex items-center justify-center rounded-md w-[42px] h-[42px] ltr:mr-[12px] rtl:ml-[12px]"
              >
                <i class="material-symbols-outlined"> airplay </i>
              </div>
              <div>
                <span class="block text-lg text-white font-semibold">
                  320
                </span>
                <span class="block text-gray-200"> Patients </span>
              </div>
            </div>
            <div
              class="flex items-center ltr:mr-[30px] rtl:ml-[30px] ltr:last:mr-0] rtl:ml-0"
            >
              <div
                class="bg-purple-100 text-purple-500 flex items-center justify-center rounded-md w-[42px] h-[42px] ltr:mr-[12px] rtl:ml-[12px]"
              >
                <i class="material-symbols-outlined"> local_library </i>
              </div>
              <div>
                <span class="block text-lg text-white font-semibold"> 18 </span>
                <span class="block text-gray-200"> Surgeries </span>
              </div>
            </div>
          </div>
        </div>
        <div class="sm:col-span-2">
          <div class="text-center mt-[20px] sm:mt-0">
            <img
              src="@/assets/images/female-doctor.png"
              class="inline-block"
              alt="female-doctor"
            />
          </div>
        </div>
      </div>
    </div>
    <img
      src="@/assets/images/vector1.png"
      class="absolute ltr:right-0 rtl:left-0 -z-[1] top-0"
      alt="vector-image"
    />
    <img
      src="@/assets/images/vector2.png"
      class="absolute ltr:right-0 rtl:left-0 -z-[1] bottom-0"
      alt="vector-image"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "YourScheduleToday",
});
</script>
